import { User } from '@/models/auth';
import { Booking, CreateBooking } from '@/models/bookings';
import { Header } from '@/models/state';

export interface State {
  apiKey: string;
  user?: User;
  bookingUrl: string;
  editBooking: string;
  instant_booking: boolean;
  createBooking: CreateBooking;
  monthly_bookings: Booking[];
  lastUrl: string;
  header: Header;
  logout_from_ms: boolean;
}

const state: State = {
  apiKey: '',
  user: undefined,
  bookingUrl: '',
  editBooking: '',
  instant_booking: false,
  createBooking: {},
  monthly_bookings: [],
  lastUrl: '',
  header: {
    title: 'Poolcar',
    subtitle: '',
  },
  logout_from_ms: false,
};

export default state;
